var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"markdown-text",staticClass:"v-markdown v-markdown-result mt-4 resized",class:{ 'small': _vm.$vuetify.breakpoint.smAndDown  },style:(`color:${_vm.color}`),domProps:{"innerHTML":_vm._s(_vm.compiledMarkdown)}})
}
var staticRenderFns = []

export { render, staticRenderFns }